import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TipoTemplate } from '../models/tipo-template';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class TipoTemplateService extends ResourcefulService<TipoTemplate>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, TipoTemplate);
    }
}
